import Head from 'next/head';
import { FC } from 'react';
import { GA_MEASUREMENT_ID } from '../src/common/constants/constants';

export interface GoogleAnalyticsScriptsProps {
  accountId?: string;
}

// GA4 gtag.js loader and config. Rendered by the meta Header, and directly by
// pages that don't use the Header (e.g. like/dislike) so window.gtag exists everywhere.
export const GoogleAnalyticsScripts: FC<GoogleAnalyticsScriptsProps> = ({ accountId }) => (
  <Head>
    {/* async: the inline dataLayer stub below queues events until the
        library arrives, so nothing is lost — but the fetch no longer blocks
        first paint on a 99%-mobile audience. */}
    <script async src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`} />
    <script
      dangerouslySetInnerHTML={{
        __html: `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA_MEASUREMENT_ID}'${
          accountId === undefined
            ? ''
            : `, {
      account_id: "${accountId}"
    }`
        });
  `,
      }}
    />
  </Head>
);
